import React, { useState } from "react";

const DOCS = [
  { file: "index.html", num: "1", label: "Cài đặt Agent" },
  { file: "server-setup.html", num: "2", label: "Dựng máy chủ · Runbook" },
  { file: "system-flow.html", num: "3", label: "Luồng hệ thống" },
];

const base = `${process.env.PUBLIC_URL || ""}/docs/`;

export default function DocsView() {
  const [active, setActive] = useState(DOCS[0].file);

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      {/* Tab Selector Header */}
      <div style={{
        display: "flex",
        gap: "8px",
        marginBottom: "18px",
        flexWrap: "wrap",
        alignItems: "center",
      }}>
        {DOCS.map((d) => {
          const isAct = active === d.file;
          return (
            <span
              key={d.file}
              onClick={() => setActive(d.file)}
              style={isAct ? activeTabStyle : inactiveTabStyle}
              className="docs-nav-tab"
            >
              <span style={{
                display: "inline-flex",
                width: "18px",
                height: "18px",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
                background: isAct ? "var(--primary)" : "rgba(128, 128, 128, 0.18)",
                color: isAct ? "#fff" : "var(--dim)",
                fontSize: "11px",
                fontWeight: 700,
              }}>
                {d.num}
              </span>
              {d.label}
            </span>
          );
        })}

        <a
          href={`${base}${active}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            marginLeft: "auto",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "8px 14px",
            borderRadius: "10px",
            fontSize: "13px",
            fontWeight: 600,
            color: "var(--dim)",
            background: "var(--surface2)",
            border: "1px solid var(--border)",
            textDecoration: "none",
            transition: "all 0.2s ease",
          }}
          className="docs-new-tab-btn"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
            <path d="M15 3h6v6M10 14 21 3"></path>
          </svg>
          Mở tab mới
        </a>
      </div>

      {/* Embedded Iframe Panel */}
      <div style={{
        flex: 1,
        borderRadius: "14px",
        background: "var(--surface)",
        border: "1px solid var(--border)",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}>
        <iframe
          key={active}
          title="Tài liệu MonitorServer"
          src={`${base}${active}`}
          style={{
            flex: 1,
            width: "100%",
            height: "640px",
            border: "none",
            background: "#0a0d13",
          }}
        />
      </div>

      <style>{`
        .docs-nav-tab:hover {
          color: var(--text) !important;
          background: var(--surface2) !important;
        }
        .docs-new-tab-btn:hover {
          color: var(--text) !important;
        }
      `}</style>
    </div>
  );
}

const activeTabStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: "8px",
  padding: "8px 14px",
  borderRadius: "10px",
  fontSize: "13px",
  fontWeight: "700",
  color: "var(--text)",
  background: "var(--surface)",
  border: "1px solid var(--border)",
  cursor: "pointer",
  transition: "all 0.2s ease",
};

const inactiveTabStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: "8px",
  padding: "8px 14px",
  borderRadius: "10px",
  fontSize: "13px",
  fontWeight: "600",
  color: "var(--dim)",
  background: "transparent",
  border: "1px solid transparent",
  cursor: "pointer",
  transition: "all 0.2s ease",
};
